import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { ISubscription } from "../../../Pages/Exam/IExam";

export const ListSubscriptionSlice = createSlice({
  name: "ListSubscriptionSlice",
  initialState: {} as IReduxState<ISubscription[]>,
  reducers: {
    listSubscription: (state, _: PayloadAction<ISubscription>) => {
      state.isLoading = true;
    },
    successlistSubscription: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failurelistSubscription: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearListSubscription: (state) => {
      state.data = {};
    },
  },
});

export const {
  failurelistSubscription,
  clearListSubscription,
  successlistSubscription,
  listSubscription,
} = ListSubscriptionSlice.actions;

export default ListSubscriptionSlice.reducer;
